export default [
    {
        path: 'batch-eligibility',
        name: 'batch-page',
        component: () => import('../views/BatchPage'),
    },
];
